import { FC, memo } from 'react'

import { ArrowRightIcon, Button, HomeIcon, LoanIcon, MoneyBagIcon, ShopIcon, Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Breadcrumb } from 'components/breadcrumb'
import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { HeroProps } from './hero.model'
import * as S from './styles'

const Hero: FC<HeroProps> = memo(({ onClick }) => {
  const { isMobile } = useWindowSize()

  const BreadcrumbLinks = [
    { label: 'Home Equity' }
  ]

  return (
    <S.Hero>
      <Grid col={{ phone: 1 }}>
        <Col col={{ tablet: 5, desktop: 4 }} start={{ tablet: 1, desktop: 2 }}>
          <S.Infos>
            <Breadcrumb items={BreadcrumbLinks} />
            <Text as="h1" size="heading2" weight="medium">
              Home Equity
            </Text>
            <Text className="hero-description" size="body1" color="var(--colors-neutral-text-weak)">
              Use o seu imóvel e tenha acesso mais rápido ao empréstimo, com o nosso processo simplificado e 100% digital.
            </Text>
            <Text className="text-credit" size="heading4" weight="medium">
              Crédito a partir de
            </Text>
            <Text className="text-value" size="heading2" weight="medium" color="var(--colors-pink-text-default)">
              R$ 50 mil
            </Text>
            <Text className="list-title" size="body1" color="var(--colors-neutral-text-weak)">
              Para diversas finalidades, como:
            </Text>
            {isMobile && 
              <Button
                size="lg"
                onClick={onClick}
              >
                Simular agora
              </Button>
            }
            <S.LoanInfos>
              <S.LoanInfosItem>
                <HomeIcon color="var(--colors-cyan-icon-default)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Comprar ou reformar imóvel
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <ShopIcon color="var(--colors-cyan-icon-default)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Abrir o próprio negócio
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <MoneyBagIcon color="var(--colors-cyan-icon-default)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Capital de giro para a empresa
                </Text>
              </S.LoanInfosItem>
              <S.LoanInfosItem>
                <LoanIcon color="var(--colors-cyan-icon-default)" />
                <Text size="body2" color="var(--colors-neutral-text-weak)">
                  Organizar as dívidas
                </Text>
              </S.LoanInfosItem>
            </S.LoanInfos>
            {!isMobile && 
              <Button size="lg" onClick={onClick}>
                Simular agora <ArrowRightIcon />
              </Button>
            }
          </S.Infos>
        </Col>
        {!isMobile && 
          <Col col={{ tablet: 7, desktop: 7 }}>
            <S.ImageWrapper>
              <NextImage
                src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/home-equity/hero.png`}
                alt="Mulher atendendo a porta"
                width="654"
                height="485"
                quality={90}
                priority
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "auto"
                }} />
            </S.ImageWrapper>
          </Col>
        }
      </Grid>
    </S.Hero>
  );
})

Hero.displayName = 'Hero'

export default Hero
